import placeholder from '../modules/placeholder';
import randomGenerator from '../modules/random-generator';
import passwordVisibility from '../modules/password-visibility';
import initAliasDeleteModal from '../modules/alias-delete-modal';
import initForwardDeleteModal from '../modules/forward-delete-modal';
import { Modal } from 'bootstrap'

const initialize = () => {
    placeholder('eu-temp');

    randomGenerator();
    passwordVisibility();
    initAliasDeleteModal();
    initForwardDeleteModal();

    $('#pop3-premium-enable-btn').on('click', function () {
        $('#status').val('open');
        $('#pop3-enable-btn').click();
    });

    const pop3PasswordEl = document.getElementById('pop3PasswordModal');
    if (pop3PasswordEl) {
        let pop3PasswordModal = new Modal(pop3PasswordEl, {
            focus: false
        });
        pop3PasswordModal.hide();
    }

    let clickHandlerDefined = false;

    $('#pop3-enable-btn').on('click', function () {
        if (clickHandlerDefined) {
            return;
        }
        let checkboxChecked = $(this).is(":checked");
        if (!checkboxChecked) {
            return;
        }
        //if set trial
        if($.inArray($('#status').val(), ['trial', 'closed']) >= 0 ) {
            //if set trial and no premium left show buy quot window
            //if set trial and has premium show switch to premium confirmation window
            $(this)
                .attr('data-bs-toggle', 'modal')
                .attr('data-bs-target', '#pop3PremiumEnableModal')
                .prop('checked', false)

            ;
            let pop3PremiumEnableModal = new Modal(document.getElementById('pop3PremiumEnableModal'));
            if (!pop3PremiumEnableModal) {
                return;
            }
            pop3PremiumEnableModal.show();
            return;
        }

        $(this).removeClass('purchase-more')
        $(this).attr('data-bs-toggle', '');
    });

    $('#email-client-settings').on('click', function(){
        event.preventDefault();
        event.stopPropagation();
        window.open($(this).attr('href'),'_blank').focus();
    });
};

export default initialize;
